import React, { useEffect, useRef } from 'react';
import { BaseRuleActionHandler } from '../models/BaseRuleActionHandler';
import { IRuleActionModel } from '../models/IRuleActionModel';
import { InlineMapping } from '@decisions/server/DecisionsFramework/Design/Flow/InlineMapping';
import { TextItem } from 'domains/designers/TruthTable/components';
import { shortenString } from 'utils/StringUtils';
// import './ActionInlineEditor.less'

interface IActionInlineEditorProps extends React.HTMLProps<HTMLDivElement> {
  sessionId: string;
  actionModel: IRuleActionModel;
  handler: BaseRuleActionHandler;
  isDebug: boolean;
}

/**
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function ActionInlineEditor({
  actionModel,
  handler,
  sessionId,
  isDebug,
  ...htmlProps
}: IActionInlineEditorProps) {
  const inlineEditorHolderRef = useRef<HTMLDivElement>(null);

  const inlineMapping = actionModel.getClientData('InlineMapping') as InlineMapping;

  useEffect(() => {
    if (!isDebug && inlineEditorHolderRef.current && !IS_TEST) {
      inlineEditorHolderRef.current.innerHTML = '';

      const editor = handler.getInlineEditor({
        actionId: actionModel.ActionId,
        actionName: actionModel.ActionName,
        sessionId: sessionId,
        //we need holder to find mapping context
        holder: inlineEditorHolderRef.current,
        inlineMapping,
      });

      if (editor) {
        inlineEditorHolderRef.current.appendChild(editor);
      }
    }
  }, [actionModel, actionModel.ActionName, handler, sessionId, inlineMapping, isDebug]);

  if (isDebug) {
    return <TextItem>{shortenString(inlineMapping?.Value, 70, { separator: '.' })}</TextItem>;
  }
  return <div ref={inlineEditorHolderRef} {...htmlProps}></div>;
}
